import { getManagementApiBaseUrl } from '../../utils/management-api';
import { id } from '@monorepo/tools/src/lib/types/primitives';
import { CrudEndpoint } from './crud.endpoint';

export class DomainFactorsEndpoint extends CrudEndpoint {
	constructor() {
		super('domain-factors');
	}

	private get domainFactorsRootApi(): string {
		return getManagementApiBaseUrl();
	}

	private get domainFactorsBaseUrl(): string {
		return `${this.domainFactorsRootApi}/domain-factors`;
	}

	list() {
		return this.domainFactorsBaseUrl;
	}

	create() {
		return this.domainFactorsBaseUrl;
	}

	get(id: id) {
		return `${this.domainFactorsBaseUrl}/${id}`;
	}

	getByDomain(domain: string) {
		return `${this.domainFactorsBaseUrl}/domain/${domain}`;
	}

	getByCampaign(campaignId: id) {
		return `${this.domainFactorsBaseUrl}/campaign/${campaignId}`;
	}

	edit() {
		return `${this.domainFactorsBaseUrl}/`;
	}

	delete() {
		return `${this.domainFactorsBaseUrl}/`;
	}
}
